import classNames from "classnames";

interface TealBoxProp {
  children: any;
  center?: boolean;
  maxWidth: string;
}

const TealBox: React.FC<TealBoxProp> = ({ children, center, maxWidth }) => (
  <div className={classNames("teal-box", { "teal-box--center": center })}>
    <div className="container">
      <div className="teal-box__inner" style={{ maxWidth }}>
        {children}
      </div>
    </div>
  </div>
);

export default TealBox;
